export function parseElevioArticleId(url) {
    var _a, _b;
    try {
        const articleId = (_b = (_a = url.match(/\/articles\/(\d+)/)) === null || _a === void 0 ? void 0 : _a.at(1)) !== null && _b !== void 0 ? _b : undefined;
        return articleId;
    }
    catch (_c) {
        return undefined;
    }
}
